import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';

import { BodyTableCell } from '../shared';
import { dateFormatter, toCapitalized, currencyFormatter } from 'core/helpers/formatters';
import { Label, Button } from 'core';
import { convertUTCToET } from 'customer/components/policy/dates';
import useSession from 'core/hooks/use-session';
import RevertVersionModal from '../revert-version-modal';
import styles, { useStyles } from '../versions.styles';

const TableCell = withStyles(styles)(({ children, classes }) => (
  <BodyTableCell classes={{ tableCell: classes.bigTableCell }}>{children}</BodyTableCell>
));

TableCell.propTypes = {
  children: PropTypes.node.isRequired
};

export const ListBody = ({
  itemsChanged,
  coverageChange,
  version,
  updatedDateTime,
  username,
  internalNotes,
  changeInPremium,
  classes,
  showTotalPriceColumn,
  totalPrice,
  currentVersion,
  policyType,
  closeVersionHistoryModal
}) => {
  const [openRevertModal, setOpenRevertModal] = useState(false);
  const [versionToRevertTo, setVersionToRevertTo] = useState(currentVersion);
  const { canRevertPolicyDetails } = useSession();

  const date = convertUTCToET(updatedDateTime);
  const style = useStyles();

  return (
    <>
      {canRevertPolicyDetails && (
        <RevertVersionModal
          open={openRevertModal}
          onClose={() => setOpenRevertModal(false)}
          versionToRevertTo={versionToRevertTo}
          policyType={policyType}
          closeVersionHistoryModal={closeVersionHistoryModal}
        />
      )}
      <TableRow>
        <TableCell>{`00${version}`.substr(-3)}</TableCell>
        <TableCell>
          <span className={classes.dateInfo}>{dateFormatter(updatedDateTime)}</span>
          <Label type="infoLabel">{date} ET</Label>
        </TableCell>
        <TableCell>{username !== 'initial-purchase' ? toCapitalized(username) : 'Initial Purchase'}</TableCell>
        <TableCell>{toCapitalized(coverageChange) || 'None'}</TableCell>
        <TableCell>{toCapitalized(itemsChanged) || 'None'}</TableCell>
        <TableCell>
          <span className={classes.internalNotes}>{internalNotes || ''}</span>
        </TableCell>
        <TableCell>{currencyFormatter(changeInPremium)}</TableCell>
        {showTotalPriceColumn && (
          <TableCell>
            <span className={!totalPrice ? style.emptyState : null}>
              {totalPrice ? currencyFormatter(totalPrice) : `View this version's dec page for total price`}
            </span>
          </TableCell>
        )}
        {canRevertPolicyDetails && currentVersion !== version && (
          <TableCell>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setVersionToRevertTo(version);
                setOpenRevertModal(true);
              }}
            >
              Revert
            </Button>
          </TableCell>
        )}
        {canRevertPolicyDetails && currentVersion === version && (
          <TableCell>
            <Label type="italicLight">This is the current version</Label>
          </TableCell>
        )}
      </TableRow>
    </>
  );
};

ListBody.propTypes = {
  itemsChanged: PropTypes.string.isRequired,
  coverageChange: PropTypes.string.isRequired,
  version: PropTypes.number.isRequired,
  updatedDateTime: PropTypes.string.isRequired,
  changeInPremium: PropTypes.number,
  username: PropTypes.string.isRequired,
  internalNotes: PropTypes.string,
  state: PropTypes.string,
  classes: PropTypes.object.isRequired,
  showTotalPriceColumn: PropTypes.bool,
  totalPrice: PropTypes.number,
  currentVersion: PropTypes.number,
  policyType: PropTypes.string.isRequired,
  closeVersionHistoryModal: PropTypes.func.isRequired
};

ListBody.defaultProps = {
  internalNotes: undefined,
  changeInPremium: 0.0,
  state: undefined,
  showTotalPriceColumn: false,
  totalPrice: undefined
};

export default withStyles(styles)(ListBody);
